import { InputSelect } from '@vrplatform/components';
import type { SelectItem } from '@vrplatform/components';
import type { CurrencyEnum } from '@vrplatform/data';
import { sortBy } from '@vrplatform/utils';
import { currencies } from '@vrplatform/ui-common';
import { useMemo } from 'react';

type Props = {
  value: CurrencyEnum | null;
  setValue: (value: SelectItem<CurrencyEnum> | null) => void;
  disabled?: boolean;
  error: boolean;
  name?: string;
  loading?: boolean;
};

export const InputCurrency = ({
  setValue,
  value: initial,
  error,
  disabled,
  name,
  loading: loadingMutation,
  ...props
}: Props) => {
  const { options, pinned, all } = useMemo(() => {
    const opts = sortBy(
      Object.entries(currencies).map<SelectItem<CurrencyEnum>>(
        ([code, currency]) => ({
          label: currency.currencyName,
          value: code.toLowerCase(),
        })
      ),
      'label',
      'asc'
    );

    const pinned = ['usd', 'eur', 'gbp'];

    return {
      options: opts.filter((o) => !pinned.includes(o.value)),
      pinned: opts.filter((o) => pinned.includes(o.value)),
      all: opts,
    };
  }, []);

  const value = useMemo(
    () => all.find((o) => o.value === initial) || null,
    [all, initial]
  );

  return (
    <InputSelect
      type="single"
      value={value}
      setValue={setValue}
      name={name}
      data={{
        options,
        sort: null,
      }}
      inputProps={{
        error,
        disabled,
        placeholder: options[0]?.label || 'Select type',
        loadingMutation,
      }}
      dropdownProps={{
        width: 'target',
      }}
      pinnedItems={pinned}
      {...props}
    />
  );
};
